import { AlertDescription } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

export default function ChakraAlertDescription({ children, ...rest }) {
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <AlertDescription color={darkMode ? 'white' : 'black'} {...rest}>
            {children}
        </AlertDescription>
    );
}
